let eventId = null

export function setEventContext(newEventId) {
    eventId = newEventId
}

export function getEventContext() {
    return { eventId }
}